// Store del módulo QR. Compone un archivo por pantalla (Carpetas, Codigos y Dashboard),
// que es lo que viene del servidor, más el cupo del plan (Cupo), y agrega los colores
// recientes del selector de color.
//
// Los nombres de estado, mutaciones, getters y acciones tienen que ser únicos entre los
// archivos: se esparcen en un mismo espacio de nombres, como en el store de EPP.
import { qrColorError } from "@/utils/qr";
import { CarpetasState, CarpetasMutations, CarpetasActions } from "./Carpetas";
import { CodigosState, CodigosMutations, CodigosActions } from "./Codigos";
import { DashboardState, DashboardMutations, DashboardActions } from "./Dashboard";
import { CupoState, CupoMutations, CupoGetters, CupoActions } from "./Cupo";

// Cuántos colores recientes se recuerdan por empresa
const MAX_COLORES = 12;

export default {
  namespaced: true,
  state: () => ({
    // Colores recientes por empresa, solo mientras dura la sesión. Guardarlos en el
    // servidor sigue pendiente de integración.
    savedColors: {},
    ...CarpetasState(),
    ...CodigosState(),
    ...DashboardState(),
    ...CupoState(),
  }),
  getters: {
    colorsForCompany: (state) => (company) => state.savedColors[String(company)] || [],
    ...CupoGetters,
  },
  mutations: {
    ...CarpetasMutations,
    ...CodigosMutations,
    ...DashboardMutations,
    ...CupoMutations,
    SAVE_COLOR(state, { company, color }) {
      if (company == null || company === "" || qrColorError(color)) return;
      const colors = [
        color,
        ...(state.savedColors[String(company)] || []).filter((value) => value !== color),
      ].slice(0, MAX_COLORES);
      state.savedColors = { ...state.savedColors, [String(company)]: colors };
    },
    CLEAR(state) {
      state.savedColors = {};
      Object.assign(state, CarpetasState(), CodigosState(), DashboardState(), CupoState());
    },
  },
  actions: {
    ...CarpetasActions,
    ...CodigosActions,
    ...DashboardActions,
    ...CupoActions,
  },
};

// Al cerrar sesión se vacía todo el módulo: las carpetas, los códigos y las lecturas de
// una empresa no deben verse mientras carga la sesión siguiente.
export function qrSesionPlugin(store) {
  store.subscribe((mutation) => {
    if (mutation.type === "loginModule/CLEAR_USER_DATA") store.commit("qrModule/CLEAR");
  });
}
